document.addEventListener('DOMContentLoaded', function() {
    function updateTankOption() {
        const tankSummaryRow = document.querySelector('.summary-row[type="tank"]');
        if (tankSummaryRow) {
            const optionName = tankSummaryRow.querySelector('.change-option-summary .option-name').textContent.trim();
            const tankInputField = document.querySelector('input[name="Tank Colour"]');
            if (tankInputField) {
                tankInputField.value = optionName;
            }
        }
    }

    function updateSeatOption() {
        const seatSummaryRow = document.querySelector('.summary-row[type="seat"]');
        if (seatSummaryRow) {
            const optionName = seatSummaryRow.querySelector('.change-option-summary .option-name').textContent.trim();
            const seatInputField = document.querySelector('input[name="Seat Colour"]');
            if (seatInputField) {
                seatInputField.value = optionName;
            }
        }
    }

    function updateMudguardOption() {
        const mudguardSummaryRow = document.querySelector('.summary-row[type="mudguards"]');
        if (mudguardSummaryRow) {
            const optionName = mudguardSummaryRow.querySelector('.change-option-summary .option-name').textContent.trim();
            const mudguardInputField = document.querySelector('input[name="Mudguard Colour"]');
            if (mudguardInputField) {
                mudguardInputField.value = optionName;
            }
        }
    }

    function updateSuspension() {
        const kTechSummaryRow = document.querySelector('.summary-row[data-row-id="Suspension K-Tech Razor Lite"] input');
        if (kTechSummaryRow) {
            const kTechInputField = document.querySelector('input[name="K-Tech Razor Lite Suspension"]');
            if (kTechInputField) {
                kTechInputField.value = kTechSummaryRow.checked ? 'K-Tech_Razor_Lite' : 'Default';
            }
        }
    }

    function updateExtras() {
        const extrasCheckboxes = document.querySelectorAll('input[name="extras"]');
        const extrasInputField = document.querySelector('input[name="Extra Products"]');

        if (extrasInputField) {
            const selectedExtras = Array.from(extrasCheckboxes)
                .filter(checkbox => checkbox.checked)
                .map(checkbox => checkbox.dataset.productName);
          
            extrasInputField.value = selectedExtras.length > 0 ? selectedExtras.join(', ') : 'No';
        }
    }

    function updatePannier() {
        const Pannier = document.querySelector('.summary-row[data-row-id="Sacoche Maeving"] input');
        if (Pannier) {
            const PannierInputField = document.querySelector('input[name="Maeving Roll Top Pannier"]');
            if (PannierInputField) {
                PannierInputField.value = Pannier.checked ? 'Maeving Roll-Top Pannier' : 'No';
            }
        }
    }

    function updateSecurity() {
        const Security = document.querySelector('.summary-row[data-row-id="Traqueur de Sécurité"] input');
        if (Security) {
            const SecurityInputField = document.querySelector('input[name="GPS Security Tracker"]');
            if (SecurityInputField) {
                SecurityInputField.value = Security.checked ? 'Yes' : 'No';
            }
        }
    }

    function updateBaseSKU() {
        const selected_variant_id = $("input.variant-to-be-added").val();
        const selected_base_sku = $('[name="variant-selector"][data-variantid="' + selected_variant_id + '"]').data('sku');
        $("input[name='Base SKU']").val(selected_base_sku)
    }

    const financeCheckbox = document.querySelector('.finance-checkbox input[type="checkbox"]');

    function toggleFinanceCheckbox() {
        const checkboxUnchecked = document.querySelector('.finance-checkbox .checkbox-unchecked-summary');
        const checkboxChecked = document.querySelector('.finance-checkbox .checkbox-checked-summary');
        const financeInputField = document.querySelector('input[name="Finance"]');

        document.querySelector('.finance-text').addEventListener('click', function() {
            if (financeCheckbox.checked) {
                financeCheckbox.checked = false;
                checkboxUnchecked.style.display = 'block';
                checkboxChecked.style.display = 'none';
                financeInputField.value = 'No';
            } else {
                financeCheckbox.checked = true;
                checkboxUnchecked.style.display = 'none';
                checkboxChecked.style.display = 'block';
                financeInputField.value = 'Yes';
            }
        });
    }

    updateTankOption();
    updateSeatOption();
    updateMudguardOption();
    updateSuspension();
    updateExtras();
    updatePannier();
    updateSecurity();
    updateBaseSKU()
    if (financeCheckbox) {
        toggleFinanceCheckbox();
    }
      
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                updateTankOption();
                updateSeatOption();
                updateMudguardOption();
                updateSuspension();
                updateExtras();
                updatePannier();
                updateSecurity();
                updateBaseSKU();
                if (financeCheckbox) {
                    toggleFinanceCheckbox();
                }

                getSKU();
            }
        });
    });

    const targetNode = document.querySelector('.summary');
    if (targetNode) {
        observer.observe(targetNode, { childList: true, subtree: true });
    }
});